import React, { Component } from 'react';
import KaminskyPic from '../../images/KaminskyPic.jpeg';

const largerDivStyle = {
  width: "100%",
  boxSizing: "borderBox",
  margin: "auto",
  paddingTop: "40px",
  paddingBottom: "120px"
};

const imgStyle = {
  float: "left",
  height: "40%",
  width: "22%",
  position: "absolute",
};

const innerDivStyle = {
    float: "right",
    width: "65%",
    paddingBottom: "120px"
};

const textStyle = {
  fontFamily: "'Trebuchet MS', Helvetica, sans-serif",
  textAlign: "justify",
  fontSize: "16px"
};

class KaminskyBio extends Component {  
  render() {
    return (
      <div style={largerDivStyle}>
        <img src={KaminskyPic} style={imgStyle} alt="Neta's pic" />
        <div style={innerDivStyle}>
          <p style={textStyle}>
            Neta Kaminsky is an accomplished holistic healer who integrates many 
            different techniques in her unique method for diagnosis and treatment 
            of low and disrupted energy states in clients.
            <br/><br/>
            Neta graduated from the Tel Aviv University with a degree in Economics 
            and specialization in Computer Programming and System Analysis in JAVA. 
            It wasn'’'t until a car accident in 2007 that Neta was prompted to look 
            into alternative healing methods and thus found her energetic capabilities. 
            This, in turn, led to a major change in her life and career.Neta started 
            studying with different world - renowned experts in the fields of Biorgonomy 
            (Noga Gazit), Recall Healing(Gilbert Renoir), Aromatherapy(Chaim Schloss), 
            Pendulum Healing and Reiki.
            <br/><br/>
            Over the course of thousands of sessions with clients, Neta has developed her 
            own unique method for energy identification and energy treatment for a diverse 
            range of conditions.Using her methods, she coaches her clients towards building 
            a new awareness into their conditions and helps them achieve higher levels of 
            energy which leads to an enhanced state of wellbeing.
          </p>
        </div>
      </div>
    )
  }
}

export default KaminskyBio;